import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { AccountService } from '../../../services/account.service';
import { AuthService } from "../../../services/auth.service";
import { Router, ActivatedRoute, RouteReuseStrategy, RouterModule } from '@angular/router';
import { Utilities } from '../../../services/utilities';
import { UserEdit } from '../../../models/user-edit.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-account-confirm',
  templateUrl: './account-confirm.component.html',
  styleUrls: ['./account-confirm.component.css'],
  imports: [
    CommonModule,
  ],
  providers: [
  ]
})
export class AccountConfirmComponent implements OnInit {

  user: UserEdit = new UserEdit();
  userIdParam: string;
  isAdmin: boolean = false;

  public constructor(private alertService: AlertService, private accountService: AccountService,
    private authService: AuthService, public router: Router, private activeRoute: ActivatedRoute) {

    this.activeRoute.params.subscribe(params => {
      console.log('Change to params');
      if (params && params.id) {
        this.userIdParam = params.id;
      }
      this.loadData(params);
    })
  }

  public ngOnInit(): void {
    if (this.authService.isSessionExpired) {
      this.router.navigateByUrl('/account/login');
    }
    else {
      this.userIdParam = this.activeRoute.snapshot.params['id'];
    }

    //load user's data if point reached
    if (this.userIdParam) {
      this.loadData(this.userIdParam);
    }
    this.isAdmin = this.accountService.IsAdminRole();
  }

  loadData(params: any) {
    const getUser$ = this.userIdParam === 'me'
      ? this.accountService.getUserSelf()
      : this.accountService.getUser(this.userIdParam);

    getUser$.subscribe({
      next: user => {
        Object.assign(this.user, user);
        this.user.confirmEmail = user.email;
        this.user.roles = this.accountService.getRoleLabels(this.user.roles);
      },
      error: (error) => {
        if (error.url.includes('Account/Login')) {
          this.authService.logout();
          this.authService.redirectLogoutUser();
        }

        this.alertService.showStickyMessage(
          'Load Error', `Unable to retrieve user from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
          MessageSeverity.error, error);
      }
    });
  }

  goToNewUser() {
    this.router.navigate(['/account/edit']);
  }

  goToSearch() {
    this.router.navigate(['/account/search']);
  }

  goToEditUser(id: string) {
    this.router.navigate(['/account/edit', id]);
  }

  goToMe() {
    this.router.navigate(['/account/edit/me']);
  }  
}

